import { Info } from "lucide-react";

// Bandeau discret affiché sur la page de destination des contenus de démonstration.
export const DemoBanner = ({ className = "" }) => (
  <div
    data-testid="demo-banner"
    className={`flex items-center gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 ${className}`}
  >
    <Info size={14} className="shrink-0" />
    <span>
      Contenu de <strong>démonstration</strong> — exemple fictif présenté pour illustrer la plateforme.
    </span>
  </div>
);

export default DemoBanner;
